import React, { Component } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18n-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { storageKeys } from 'settings';
import { APIHandler, Image, StorageHandler, Progress, DataHandler } from 'C4';

const createSubAppUrl = (type, subAppId, chapterId, email, currentPage, progressPercentage, autoTranslateAI) => {
  // const demo = 'http://localhost:8081';
  const live = 'https://academy.travpromobile.com';
  let pageId = currentPage;
  const redirurl = window.location.href;
  const params = new URLSearchParams(window.location.search);
  let lang = '';
  if (params.get('lang')) {
    lang = params.get('lang');
  }
  if (progressPercentage === 100) {
    type = 'retain';
    pageId = 0;
  }

  if (autoTranslateAI) {
    // Auto translate is enabled, so we need to get the language from the local storage and use in URL
    let langLocal = localStorage.getItem('lang');
    if (langLocal) {
      langLocal = JSON.parse(langLocal);
      if (langLocal.rawData.code === 'gb') {
        lang = 'EN-GB';
      } else {
        lang = langLocal.rawData.langFile;
      }
      lang = lang.toUpperCase();
    }
    return `${live}/${type}/${subAppId}/${email}/${chapterId}/${pageId}/${
      type === 'training'
    }/${true}?lang=${lang}&redirurl=${redirurl}/main/${type}`;
  }
  return `${live}/${type}/${subAppId}/${email}/${chapterId}/${pageId}/${
    type === 'training'
  }/${true}?lang=${lang}&redirurl=${redirurl}/main/${type}`;
};

const shareAnalytics = (name, value) => {
  DataHandler.matchAppId().then((appId) => {
    StorageHandler.load(storageKeys.user).then((userObj) => {
      let email = '';
      ({ email } = userObj);
      APIHandler.trackEvent(appId, email, 'levelii', name, value, value).then(() => {});
    });
  });
};
export default class SubAppButton extends Component {
  constructor(props) {
    super(props);

    const { src, customName, appId } = this.props;

    let newSrc = src;
    const name = customName.length > 0 ? customName : 'Icon-180';
    if (newSrc.length === 0) {
      if (appId > 500) {
        newSrc = `https://front.travpromobile.com/${appId}/logo.png`;
      } else {
        newSrc = `https://cdn.travpromobile.com/apptool/app/${appId}/images/${name}.png`;
      }
    }
    this.state = {
      appId,
      pageId: 0,
      src: newSrc,
      redir: '',
    };
  }

  render() {
    const { src } = this.state;
    const {
      appId,
      size,
      progress: userProgress,
      name,
      type,
      chapterId,
      email,
      locked,
      pageId,
      backgroundImage,
      citys,
      comingSoon,
      aiAutoTranslate,
    } = this.props;
    const percentage = Math.round((userProgress.progress / userProgress.total_pages) * 100);
    const appURL = window.location.origin;

    let buttonText;
    switch (percentage) {
      case 100:
        buttonText = i18n.translate('trainingScreens.restart');
        break;
      case undefined:
      case 0:
        buttonText = i18n.translate('trainingScreens.start');
        break;
      default:
        buttonText = i18n.translate('trainingScreens.continue');
    }

    if (type !== 'training') {
      buttonText = i18n.translate('trainingScreens.review');
    }

    const subAppUrl = createSubAppUrl(type, appId, chapterId, email, pageId, percentage, aiAutoTranslate);

    return (
      <div className="subApp__Card" key={chapterId}>
        {locked && (
          <div className="subApp__Card--locked">
            <FontAwesomeIcon icon={['fas', 'lock']} /> <p>{i18n.translate('trainingScreens.unlockSubtitle')}</p>
          </div>
        )}
        <img src={backgroundImage} alt="" className="subApp__Card--backgroundImage" />
        <div className="subApp__Card--content">
          <div className="overlay gradient" />
          <img src={src} className="logo" />
          <div className="subApp__Card--start">
            <a
              href={subAppUrl}
              onClick={() => {
                shareAnalytics('open-training', chapterId);
              }}
            >
              <button>
                {type === 'training' && (
                  <React.Fragment>
                    {percentage >= 100 && (
                      <div className="chapterComplete">
                        <FontAwesomeIcon icon={['far', 'check-circle']} />
                        <span>{name.split('|').pop()}</span>
                      </div>
                    )}
                    {percentage > 0 && percentage < 100 && (
                      <div className="continueChapter">
                        <FontAwesomeIcon icon={['far', 'play']} />
                        <span>{name.split('|').pop()}</span>
                      </div>
                    )}
                    {percentage === 0 && (
                      <div className="startChapter">
                        <FontAwesomeIcon icon={['far', 'play']} />
                        <span>{name.split('|').pop()}</span>
                      </div>
                    )}
                  </React.Fragment>
                )}
                {type !== 'training' && <span>{name.split('|').pop()}</span>}
                {type === 'training' && <Progress id={`SubAppButton_${src}`} value={percentage} />}
              </button>
            </a>
          </div>

          <div className="cityButtons">
            {citys.map((city, index) => (
              <a
                key={index}
                href={createSubAppUrl(
                  type,
                  city.appId,
                  city.chapterID,
                  email,
                  city.pageId,
                  city.percentage,
                  city.aiAutoTranslate,
                )}
                onClick={() => {
                  shareAnalytics('open-training', chapterId);
                }}
                className={city.comingSoon ? 'comingSoon' : ''}
              >
                <button>
                  {city.comingSoon && (
                    <div className="subApp__Card--comingSoon">
                      <FontAwesomeIcon icon={['fas', 'lock']} /> <p>Coming Soon</p>
                    </div>
                  )}
                  {city.percentage >= 100 && (
                    <FontAwesomeIcon icon={['far', 'check-circle']} className="chapterComplete" />
                  )}
                  {city.percentage > 0 && city.percentage < 100 && (
                    <FontAwesomeIcon icon={['far', 'play']} className="continueChapter" />
                  )}
                  {city.percentage === 0 && <FontAwesomeIcon icon={['far', 'play']} className="startChapter" />}
                  {city.name}
                  {type === 'training' && <Progress id={`SubAppButton_${src}`} value={city.percentage} />}
                </button>
              </a>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

SubAppButton.propTypes = {
  appId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  email: PropTypes.string,
  customName: PropTypes.string,
  src: PropTypes.string,
  locked: PropTypes.bool,
  size: PropTypes.shape({
    height: PropTypes.number,
    width: PropTypes.number,
  }),
  chapterId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  progress: PropTypes.shape({
    progress: PropTypes.number,
    last_page: PropTypes.number,
    total_pages: PropTypes.number,
    inserted_at: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }).isRequired,
  name: PropTypes.string,
  citys: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      appId: PropTypes.number,
      chapterID: PropTypes.string,
      pageId: PropTypes.number,
      comingSoon: PropTypes.bool,
    }),
  ),
  aiAutoTranslate: PropTypes.number,
};

SubAppButton.defaultProps = {
  appId: -1,
  chapterId: -1,
  customName: '',
  src: '',
  locked: false,
  size: { height: 150, width: 60 },
  pageId: 0,
  email: '',
  name: 'Level II Chapter',
  citys: [],
  comingSoon: false,
  aiAutoTranslate: 0,
};
